import { Typography } from "@mui/material";
import { useRecordContext } from "ra-core";
import { memo, useMemo } from "react";

export const NameField = memo((props) => {
    const { source } =  props;
    const record = useRecordContext(props);
    const renderPaddingLeft = useMemo(() => {
        return record.level * 15;
    }, [record]);
    return (
        <Typography variant="body2" sx={{ paddingLeft: `${renderPaddingLeft}px`}}>{record[source]}</Typography>
    )
});